import { Box, CircularProgress } from '@mui/material'
import React from 'react'

const LoadingSpinner: React.FC = ({ name }: { name?: string }) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      flexGrow={1}
    >
      <CircularProgress />
      <h1>{name}</h1>
    </Box>
  )
}

export default LoadingSpinner
